export * from './lib/gofast-layout.module';

export * from './lib/gofast-layout.component';
